import React, { Component } from 'react';
import InputTypes from '../../../common/components/InputTypes';
import { combinedMarketingLabel } from '../../../common/constants/form';

/**
 * Renders the newsletter checkbox
 */

export default class MarketingCheckbox extends Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    /**
     * Set state on change of inputs
     * @param  {obj} event
     */
    handleInputChange(event) {
        const prop = event.target.name;
        const { updateFormData } = this.props;

        const isChecked = event.target.checked;

        const checkInt = isChecked === true ? 1 : 0;

        updateFormData({ [prop]: checkInt });
    }

    render() {
        const { offerCheckbox, optInMessage } = this.props;

        const combinedOptInMessage = combinedMarketingLabel(optInMessage);

        const checkInt = offerCheckbox === 1;

        return (
            <div className="booking-checkbox">
                <InputTypes
                    layout="inverted"
                    type="checkbox"
                    name="offerCheckbox"
                    onChange={this.handleInputChange}
                    ariaLabel="offers"
                    checked={checkInt}
                    label={combinedOptInMessage}
                />
            </div>
        );
    }
}
